import React from "react";
import WarrantyRegistrationSuccessComponent from "./warranty-registration-success.component";

const WarrantyRegistrationSuccessPage = (): JSX.Element => {
  return <WarrantyRegistrationSuccessComponent />;
};

export default WarrantyRegistrationSuccessPage;
